export { default } from './MainHeaderImage';
